import api from "../../api.service";
import Swal from "sweetalert2";
import store from "../";

const createCurrentNotification = () => ({
    id: 0,
    body: null,
    createdAt: new Date().toLocaleDateString("en-GB"),
    shopId: null,
    shopName: null,
    shopImage: null,
    title: null,
    date: null,
    time: null,
    buttonText: null,
    buttonUrl: null
});

const state = {
    notificationList: [],
    shopNotificationList: [],
    currentNotification: createCurrentNotification(),
    notificationPageNumber: 1,
    notificationPageSize: 12,
    notificationTotalCount: 0,
    notificationTotalPages: 0,
    notificationSearchText: ""
};

const getters = {
    notificationList(state) {
        return state.notificationList;
    },
    shopNotificationList(state) {
        return state.shopNotificationList;
    },
    isLoadingNotification(state) {
        return state.isLoadingNotification;
    },
    currentNotification(state) {
        return state.currentNotification;
    },
    notificationPageNumber(state) {
        return state.notificationPageNumber;
    },
    notificationPageSize(state) {
        return state.notificationPageSize;
    },
    notificationTotalCount(state) {
        return state.notificationTotalCount;
    },
    notificationTotalPages(state) {
        return state.notificationTotalPages;
    },
    notificationSearchText(state) {
        return state.notificationSearchText;
    }
};

const mutations = {
    GET_NOTIFICATION_ITEMS(state, payload) {
        state.notificationList = payload.notifications;
        state.shopNotificationList = payload.shopsList;
        state.notificationPageNumber = payload.pageNumber;
        state.notificationPageSize = payload.pageSize;
        state.notificationTotalCount = payload.totalCount;
        state.notificationTotalPages = payload.totalPages;
        store.dispatch("setLoading", false);
    },
    GET_NOTIFICATIONFORSHOP_ITEMS(state, payload) {
        state.notificationList = payload;
    },
    GET_CURRENTNOTI_ITEMS(state, payload) {
        Object.assign(
            state.currentNotification,
            createCurrentNotification(),
            payload.notifications[0]
        );
    },
    SET_NOTIFICATION_SEARCH_TEXT(state, payload) {
        state.notificationSearchText = payload;
    },
    ADD_NOTIFICATION_ITEMS(state, payload) {
        if (typeof payload == "string") {
            Swal.fire({
                title: "الإضافة غير ممكنة",
                text: `${payload}.`,
                icon: "warning",
                confirmButtonText: "تم"
            });
        }
    },
    DELETE_NOTIFICATION_ITEMS(state, payload) {
        const index = state.notificationList.findIndex(
            item => item.id == payload.id
        );
        const notificationTitle =
            index >= 0 ? state.notificationList[index].title : payload.title;

        if (index >= 0) {
            state.notificationList.splice(index, 1);
        }

        if (state.currentNotification.id == payload.id) {
            Object.assign(state.currentNotification, createCurrentNotification());
        }

        Swal.fire({
            title: "تم الحذف !",
            text: `تم حذف إشعار : ${notificationTitle}.`,
            icon: "success",
            confirmButtonText: "تم"
        });
    }
};

const actions = {
    async fetchNotification(context, payload) {
        const request =
            typeof payload == "number"
                ? { id: payload }
                : { ...(payload || {}) };

        const pageNumber = request.id
            ? 1
            : request.pageNumber || context.state.notificationPageNumber;
        const pageSize = request.id
            ? 1
            : request.pageSize || context.state.notificationPageSize;
        const searchText =
            request.id != null && request.id != 0
                ? ""
                : request.searchText !== undefined
                    ? request.searchText
                    : context.state.notificationSearchText;

        context.commit("SET_NOTIFICATION_SEARCH_TEXT", searchText);
        store.dispatch("setLoading", true);

        const { data } = await api
            .query(
                `/api/Notification/GetNotifications?id=${request.id || 0}&pageNumber=${pageNumber}&pageSize=${pageSize}&searchText=${encodeURIComponent(
                    searchText || ""
                )}`
            )
            .then(data => data);

        context.commit("GET_NOTIFICATION_ITEMS", data);
    },

    async fetchNotificatioForShop(context, payload) {
        const { data } = await api
            .query(
                `/api/Notification/GetNotificationsForShop?shopId=${payload}`
            )
            .then(data => data);
        context.commit("GET_NOTIFICATIONFORSHOP_ITEMS", data);
    },

    async fetchCurrentNotification(context, payload) {
        const { data } = await api
            .query(`/api/Notification/GetNotifications?id=${payload}`)
            .then(data => data);
        context.commit("GET_CURRENTNOTI_ITEMS", data);
    },

    async deleteNotification(context, payload) {
        await api
            .delete(`/api/Notification/RemoveNotification?id=${payload.id}`)
            .then(data => data);

        context.commit("DELETE_NOTIFICATION_ITEMS", payload);

        const nextPage =
            context.state.notificationPageNumber > 1
            && context.state.notificationList.length === 0
                ? context.state.notificationPageNumber - 1
                : context.state.notificationPageNumber;

        context.dispatch("fetchNotification", {
            pageNumber: nextPage,
            pageSize: context.state.notificationPageSize,
            searchText: context.state.notificationSearchText
        });
    },
    async setNotification(context, payload) {
        const { data } = await api
            .post("/api/Notification/SetNotification", {
                Id: payload.id,
                Title: payload.title,
                Body: payload.body,
                ShopId: payload.shopId,
                ShopName: payload.shopName,
                CityIdToSend:
                    payload.CityIdToSend == 0 ? null : payload.CityIdToSend,
                Date: payload.date,
                Time: payload.time,
                ButtonUrl: payload.buttonUrl,
                ButtonText: payload.buttonText
            })
            .then(data => data);

        context.commit("ADD_NOTIFICATION_ITEMS", data);

        if (typeof data != "string") {
            context.dispatch("fetchNotification", {
                pageNumber: 1,
                pageSize: context.state.notificationPageSize,
                searchText: context.state.notificationSearchText
            });
        }
    }
};

const notificationManegment = {
    state,
    getters,
    actions,
    mutations
};
export default notificationManegment;
